import { hjGetCookie } from '@hotjar/webapp/utils/cookies';

export const getLocale = (): string | null => {
  const HJ_WEBSITE_NEXT_LOCALE = 'NEXT_LOCALE';
  const locale = hjGetCookie(HJ_WEBSITE_NEXT_LOCALE);

  return locale;
};

/**
 * Checks if the argument matches the current user's locale code
 * @param {string} localeCode
 * @returns {boolean}
 */
export const isInLocale = (localeCode: string): boolean => {
  const userLocale = getLocale();
  const isLocaleSupported = !!(userLocale && [localeCode].includes(userLocale));

  return isLocaleSupported;
};
